import { createFileRoute } from '@tanstack/react-router';

import { PlanDetailPage } from '@/pages/plans/plan-detail-page';

export const Route = createFileRoute('/plans/$code')({
  component: PlanDetail,
});

function PlanDetail() {
  const { code } = Route.useParams();
  return <PlanDetailPage code={code} />;
}
